var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.276,
    height: 53.602,
    viewBox: "0 0 47.276 53.602",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5499",
    "data-name": "Group 5499",
    transform: "translate(1391.638 11470.301)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8198",
    "data-name": "Path 8198",
    d: "M47.273,19.5V53.592H.011V21.779H0V18.908a3.538,3.538,0,0,1,1.338-2.844L22.388.422a2.041,2.041,0,0,1,2.488,0l21.05,15.642a3.537,3.537,0,0,1,1.338,2.844V19.5Z",
    transform: "translate(-1391.638 -11470.3)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8199",
    "data-name": "Path 8199",
    d: "M102.533,169.472V137.806a.38.38,0,0,1,.01-.09v-.006a.4.4,0,0,1,.151-.224l19.464-14.463a1.476,1.476,0,0,1,1.761,0l19.464,14.464a.4.4,0,0,1,.149.216.768.768,0,0,1,.025.2v3.706h.009v27.866Z",
    transform: "translate(-1491.047 -11589.292)",
    fill: "#58647a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8201",
    "data-name": "Path 8201",
    d: "M.4,714.411H4.42A7.565,7.565,0,0,1,10.82,718l6.167,9.837a3.385,3.385,0,0,0,2.864,1.6h4.178v16.808H.4Z",
    transform: "translate(-1392.023 -12162.943)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8203",
    "data-name": "Path 8203",
    d: "M799.558,714.411h-4.023a7.565,7.565,0,0,0-6.4,3.584l-6.167,9.837a3.385,3.385,0,0,1-2.864,1.6h-4.178v16.808h23.631Z",
    transform: "translate(-2143.921 -12162.943)",
    fill: "#1d3943"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8206",
    "data-name": "Path 8206",
    d: "M46.323,1193.472l-14-11.016a2.388,2.388,0,0,0-1.477-.511H17.212a2.388,2.388,0,0,0-1.477.511l-14,11.016A3.834,3.834,0,0,0,.4,1196.484v3.04H47.66v-3.04a3.834,3.834,0,0,0-1.338-3.011",
    transform: "translate(-1392.023 -12616.23)",
    fill: "#1d3943"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.249a7bc927d7826c3f6ff904361c7577.svg";
export { ForwardRef as ReactComponent };